import { REHYDRATE } from "redux-persist";
import { getBetTable } from "../common/Funcation";
import Cookies from "universal-cookie";
const cookies = new Cookies();

let initState = {
  test: "",
  userData: {},
  isAuthenticated: false,
  Header: {},
  balance: "",
  webEdit: {},
  matchCount: {},
  getSport: {},
  sportDetails: {},
  betHistory: {},
  exposure: "",
  calcOntime: false,
  calcData: {},
  scoreCard: [],
  marketListDetails: {},
  cricket: {},
  soccer: {},
  tennis: {},
  betHistoryShow: false,
  homeData: {},
  live: {},
  table: {},
  slot: {},
  fishing: {},
  egame: {},
  casinoCache: {},
  footerBetList: [],
  inPlayLive: {},
};

function skyReducer(state = initState, action) {
  switch (action.type) {
    case "AUTHENTICATION": {
      return { ...state, isAuthenticated: action.payload };
    }
    case "SHOW_BET_HISTORY": {
      return { ...state, betHistoryShow: !state.betHistoryShow };
    }
    case "USER_DATA": {
      return { ...state, userData: action.payload };
    }
    case "HEADER_DETAILS": {
      return {
        ...state,
        Header: action.payload,
        balance: action.payload.balance,
        exposure: action.payload.exposure,
      };
    }
    case "DOMAIN_DETAILS": {
      return { ...state, domainDetails: action.payload };
    }
    case "MARKET_LIST_DETAILS": {
      return { ...state, marketListDetails: action.payload };
    }
    case "EDIT_WEBSITE": {
      return { ...state, webEdit: action.payload };
    }
    case "UPDATE_USER_BALANCE": {
      return {
        ...state,
        balance: action.payload?.balance,
        exposure: action.payload?.exposure,
      };
    }
    case "SET_HOME_DATA": {
      return {
        ...state,
        homeData: action.payload,
      };
    }
    case "SET_IN_PLAY_DETAILS": {
      return {
        ...state,
        inPlayDetail: {
          inPlay: undefined,
          today: undefined,
          tomorrow: undefined,
        },
      };
    }
    case "SET_IN_PLAY_DETAILS_IN_PLAY": {
      return {
        ...state,
        inPlayDetail: { ...state.inPlayDetail, inPlay: action.payload },
      };
    }
    case "SET_IN_PLAY_DETAILS_TODAY": {
      return {
        ...state,
        inPlayDetail: { ...state.inPlayDetail, today: action.payload },
      };
    }
    case "SET_IN_PLAY_DETAILS_TOMORROW": {
      return {
        ...state,
        inPlayDetail: { ...state.inPlayDetail, tomorrow: action.payload },
      };
    }
    case "GET_SCORE_ID": {
      return {
        ...state,
        scoreCard: action.payload,
      };
    }
    case "GET_SPORTS_DETAILS": {
      let sportCopy = action.payload ? { ...action.payload } : {};
      state.sportDetails = action.payload;
      if (
        cookies.get("skyTokenFront") &&
        JSON.stringify(state?.betHistory) !== "{}" &&
        JSON.stringify(action.payload) !== "{}"
      ) {
        // console.log('GET_SPORTS_DETAILS', action.payload);
        // console.log(
        //   ":::::::::::betsHistory",
        //   JSON.stringify(state?.betHistory) !== "{}"
        // );


        // for odds
        let tableCopyActiveId = sportCopy.matchInfo?._id;
        let filteredHIstory = state?.betHistory?.filter(
          (_) => _.matchId._id === tableCopyActiveId
        );
        const OddsTable = state.calcOntime
          ? state.calcData
          : state?.betHistory?.find(
            (_) => _.betType === "odds" && _.matchId._id === tableCopyActiveId
          );
        const profitsOdds = state.calcOntime
          ? filterSportCount(
            filteredHIstory,
            "odds",
            state.calcOntime,
            state.calcData
          )
          : filterSportCount(filteredHIstory, "odds");
        let tableCopy = sportCopy.page?.data[getBetTable("odds")];
        if (OddsTable && OddsTable.winnerSelection) {
          tableCopy.forEach(
            (subElement) => (subElement.betProfit = profitsOdds[subElement.nat])
          );
        }
        sportCopy.page.data[getBetTable("odds")] = tableCopy;

        // for book maker

        let filteredBookHIstory = state?.betHistory?.filter(
          (_) => _.matchId._id === tableCopyActiveId
        );

        const BookMarkTable = state.calcOntime
          ? state.calcData
          : state?.betHistory?.find((_) => _.betType === "bookMark");
        const profitsBookMark = state.calcOntime
          ? filterSportCount(
            filteredBookHIstory,
            "bookMark",
            state.calcOntime,
            state.calcData
          )
          : filterSportCount(filteredBookHIstory, "bookMark");
        let tableCopyBookMark = sportCopy.page?.data[getBetTable("bookMark")];
        if (BookMarkTable) {
          tableCopyBookMark.forEach(
            (subElement) =>
              (subElement.betProfit = profitsBookMark[subElement.nat])
          );
        }

        sportCopy.page.data[getBetTable("bookMark")] = tableCopyBookMark;
        // FOR PRI

        let filteredpremiumHIstory = state?.betHistory?.filter(
          (_) => _.matchId._id === tableCopyActiveId
        );

        const PreTable = state.calcOntime
          ? state.calcData
          : state?.betHistory?.find((_) => _.betType === "premium");
        const profitsPreMark = state.calcOntime
          ? filterSportPreCount(
            filteredpremiumHIstory,
            "premium",
            state.calcOntime,
            state.calcData
          )
          : filterSportPreCount(filteredpremiumHIstory, "premium");
        let tableCopyPre =
          sportCopy?.pre?.data && sportCopy?.pre?.data[getBetTable("premium")];
        // console.log("::::::::", tableCopyPre);
        if (PreTable && tableCopyPre) {
          tableCopyPre?.forEach((subElement) => {
            subElement.sub_sb.forEach(
              (x) => (x.betProfit = profitsPreMark[x.nat])
            );
          });
        }
        sportCopy.page.data[getBetTable("premium")] = tableCopyPre;

        //for fancy
        // const fancyTable = state?.betHistory?.betsHistory.find(_ => _.betType === "bookMark")
        if (state?.betHistory) {
          // const profitsfancy = betsLastExposure(state?.betHistory)
          const profitsfancy = bookExposer(state?.betHistory);
          // console.log(':::::::::::::bookExposer up', profitsfancyexpo);
          let tableCopyfancy = sportCopy.page?.data[getBetTable("session")];
          if (profitsfancy.length) {
            tableCopyfancy.forEach((subElement) => {
              let findele = profitsfancy.findIndex(
                (_) => _.selection === subElement.nat
              );
              // console.log(":::::::::findele");
              if (findele !== -1) {
                subElement.betProfit =
                  profitsfancy[findele].exposure.toFixed(2);
              }
            });
          }
          sportCopy.page.data[getBetTable("session")] = tableCopyfancy;
        }
      }

      return { ...state, sportDetails: sportCopy };
    }
    case "GET_LIVE_MATCH_COUNT_FOR_VELKI": {
      return { ...state, matchCount: action.payload };
    }
    case "GET_SPORTS": {
      return {
        ...state,
        getSport: action.payload,
        [action.payload.type]: action.payload,
      };
    }
    case "GET_INPLAY_MATCHES": {
      return { ...state, inPlayLive: action.payload };
    }
    case "GET_SPORTS_LIVE_CALC": {
      return { ...state, ...action.payload };
    }
    case "USER_BET_HISTORY": {
      // let sportCopy = state.sportDetails;
      // state.betHistory = action.payload
      // console.log("GET_SPORTS_DETAILS", state.sportDetails);
      // console.log(':::::::betsHistory',filterSportCount(action.payload.betsHistory), action.payload.betsHistory )

      // const OddsTable = action?.payload?.betsHistory.find(_ => _.betType === "odds")
      // const profitsOdds = filterSportCount(action?.payload?.betsHistory, 'odds')
      // let tableCopy = sportCopy.page?.data[getBetTable('odds')]
      // if (OddsTable) {
      //     tableCopy.forEach(subElement => {
      //         if (subElement.nat === OddsTable.winnerSelection[0]) {
      //             subElement.betProfit = profitsOdds.left
      //         } else if (subElement.nat === OddsTable.winnerSelection[1]) {
      //             subElement.betProfit = profitsOdds.right
      //         } else if (subElement.nat === OddsTable.winnerSelection[2]) {
      //             subElement.betProfit = profitsOdds.draw
      //         }
      //     });
      // }
      // sportCopy.page.data[getBetTable('odds')] = tableCopy

      // // for book maker
      // const BookMarkTable = action?.payload?.betsHistory.find(_ => _.betType === "bookMark")
      // const profitsBookMark = filterSportCount(action?.payload?.betsHistory, 'bookMark')
      // let tableCopyBookMark = sportCopy.page?.data[getBetTable('bookMark')]
      // if (BookMarkTable) {
      //     tableCopyBookMark.forEach(subElement => {
      //         if (subElement.nat === BookMarkTable.winnerSelection[0]) {
      //             subElement.betProfit = profitsBookMark.left
      //         } else if (subElement.nat === BookMarkTable.winnerSelection[1]) {
      //             subElement.betProfit = profitsBookMark.right
      //         } else if (subElement.nat === BookMarkTable.winnerSelection[2]) {
      //             subElement.betProfit = profitsBookMark.draw
      //         }
      //     });
      // }

      // sportCopy.page.data[getBetTable('bookMark')] = tableCopyBookMark

      // //for fancy
      // // const fancyTable = state?.betHistory?.betsHistory.find(_ => _.betType === "bookMark")
      // const profitsfancy = betsLastExposure(action?.payload?.betsHistory)
      // let tableCopyfancy = sportCopy.page?.data[getBetTable('session')]
      // if (profitsfancy.length) {
      //     tableCopyfancy.forEach(subElement => {
      //         let findele = profitsfancy.findIndex(_ => _.selection === subElement.nat)
      //         console.log(':::::::::findele');
      //         if (findele !== -1) {
      //             subElement.betProfit = profitsfancy[findele].exposure
      //         }
      //     });
      // }

      // sportCopy.page.data[getBetTable('session')] = tableCopyfancy

      // state.sportDetails = sportCopy

      return { ...state, betHistory: action.payload };
    }
    case "FOOTER_BET_LIST": {
      return { ...state, footerBetList: action.payload };
    }
    case "SET_GAME_DATA": {
      const cacheKey = `${action.payload.type}:${action.payload.filter}:${action.payload.subName || ""}`;
      return {
        ...state,
        casinoCache: {
          ...(state.casinoCache || {}),
          [cacheKey]: action.payload.data,
        },
      };
    }
    case "LOGOUT":
      return {
        getSport: {},
        sportDetails: {},
        betHistory: {},
        footerBetList: [],
      };
    case REHYDRATE:
      return {
        ...state,
        // User: action?.payload?.User ? action?.payload?.User : '',
        // getSport: {},
        betHistoryShow: false,
        balance: '',
        scoreCard: [],
        calcOntime: false,
        calcData: {},
        getSport: {},
        cricket: {},
        soccer: {},
        tennis: {},
        sportDetails: {},
        betHistory: {},
        footerBetList: action?.payload?.footerBetList || [],
      };
    default:
      return { ...state };
  }
}

export const reducer = skyReducer;

export function filterSportCount(betsHistory, betType, calcOntime, calcData) {
  let oldExp = {};

  if (betsHistory) {
    // for await (const bet of betList)
    betsHistory.forEach((bet) => {
      if (bet.betType === betType) {
        const { winnerSelection } = bet;
        // console.log(winnerSelection);
        let profileForBet = 0;
        let exposureForBet = 0;
        if (bet.betSide === "back") {
          profileForBet = bet.profit;
          exposureForBet = bet.exposure;
        } else {
          profileForBet = bet.profit;
          exposureForBet = bet.betPlaced;
        }

        // console.log("profileForBet :: ", profileForBet);
        // console.log("exposureForBet :: ", exposureForBet);
        winnerSelection.forEach((element) => {
          // console.log(element, bet, "beeetttt");
          if (element === bet.selection) {
            if (bet.betSide === "back") {
              if (!oldExp[element]) {
                oldExp[element] = profileForBet;
              } else {
                oldExp[element] += profileForBet;
              }
            } else {
              if (!oldExp[element]) {
                oldExp[element] = -profileForBet;
              } else {
                oldExp[element] -= profileForBet;
              }
            }
          } else {
            if (bet.betSide === "back") {
              if (!oldExp[element]) {
                oldExp[element] = -exposureForBet;
              } else {
                oldExp[element] -= exposureForBet;
              }
            } else {
              if (!oldExp[element]) {
                oldExp[element] = exposureForBet;
              } else {
                oldExp[element] += exposureForBet;
              }
            }
          }
        });
      }
    });
  }
  if (calcOntime && calcData && calcData.betType === betType) {
    const { winnerSelection } = calcData;
    // console.log(winnerSelection);
    let profileForBet = 0;
    let exposureForBet = 0;
    if (calcData.betSide === "back") {
      profileForBet = calcData.profit;
      exposureForBet = calcData.exposure;
    } else {
      profileForBet = calcData.profit;
      exposureForBet = calcData.betPlaced;
    }

    // console.log("profileForBet :: ", profileForBet);
    // console.log("exposureForBet :: ", exposureForBet);
    winnerSelection.forEach((element) => {
      if (element === calcData.selection) {
        if (calcData.betSide === "back") {
          if (!oldExp[element]) {
            oldExp[element] = profileForBet;
          } else {
            oldExp[element] += profileForBet;
          }
        } else {
          if (!oldExp[element]) {
            oldExp[element] = -profileForBet;
          } else {
            oldExp[element] -= profileForBet;
          }
        }
      } else {
        if (calcData.betSide === "back") {
          if (!oldExp[element]) {
            oldExp[element] = -exposureForBet;
          } else {
            oldExp[element] -= exposureForBet;
          }
        } else {
          if (!oldExp[element]) {
            oldExp[element] = exposureForBet;
          } else {
            oldExp[element] += exposureForBet;
          }
        }
      }
    });
  }

  // return { left, right, draw };
  return oldExp;
}

export function filterSportPreCount(
  betsHistory,
  betType,
  calcOntime,
  calcData
) {
  let oldExp = {};

  if (betsHistory) {
    // for await (const bet of betList)
    betsHistory.forEach((bet) => {
      if (bet.betType === betType) {
        const { winnerSelection } = bet;
        // console.log(winnerSelection);
        let profileForBet = 0;
        let exposureForBet = 0;
        if (bet.betSide === "back") {
          profileForBet = bet.profit;
          exposureForBet = bet.exposure;
        } else {
          profileForBet = bet.betPlaced;
          exposureForBet = bet.profit;
        }

        // console.log("profileForBet :: ", profileForBet);
        // console.log("exposureForBet :: ", exposureForBet);
        winnerSelection.forEach((element) => {
          if (element === bet.subSelection) {
            if (!oldExp[element]) {
              oldExp[element] = profileForBet;
            } else {
              oldExp[element] += profileForBet;
            }
          } else {
            if (!oldExp[element]) {
              oldExp[element] = -exposureForBet;
            } else {
              oldExp[element] -= exposureForBet;
            }
          }
        });
      }
    });
  }
  if (calcOntime && calcData && calcData.betType === betType) {
    const { winnerSelection } = calcData;
    // console.log(winnerSelection);
    let profileForBet = 0;
    let exposureForBet = 0;
    if (calcData.betSide === "back") {
      profileForBet = calcData.profit;
      exposureForBet = calcData.exposure;
    } else {
      profileForBet = calcData.betPlaced;
      exposureForBet = calcData.profit;
    }

    // console.log("profileForBet :: ", profileForBet);
    // console.log("exposureForBet :: ", exposureForBet);
    winnerSelection.forEach((element) => {
      if (element === calcData.subSelection) {
        if (!oldExp[element]) {
          oldExp[element] = profileForBet;
        } else {
          oldExp[element] += profileForBet;
        }
      } else {
        if (!oldExp[element]) {
          oldExp[element] = -exposureForBet;
        } else {
          oldExp[element] -= exposureForBet;
        }
      }
    });
  }

  // return { left, right, draw };
  return oldExp;
}

const fancyBetPnl = (bet, run) => {
  const side = (bet.betSide || "").toLowerCase();
  const profit = Number(bet.profit) || 0;
  const exposure = Number(bet.exposure) || 0;
  const stake = Number(bet.betPlaced != null ? bet.betPlaced : bet.stake) || 0;
  if (side === "yes") {
    const line = Number(bet.fancyYes);
    return line <= run ? profit : -exposure;
  }
  if (side === "no") {
    const line = Number(bet.fancyNo);
    return line > run ? stake : -profit;
  }
  return 0;
};

const standForSessionBets = (sessionBets) => {
  const numberArray = {};
  if (!sessionBets || !sessionBets.length) {
    return { numberArray, exposure: 0 };
  }
  const lines = [];
  for (const bet of sessionBets) {
    const line =
      (bet.betSide || "").toLowerCase() === "yes"
        ? Number(bet.fancyYes)
        : Number(bet.fancyNo);
    if (Number.isFinite(line)) {
      lines.push(line - 1, line, line + 1);
    }
  }
  if (!lines.length) {
    return { numberArray, exposure: 0 };
  }
  const minRun = Math.min(...lines);
  const maxRun = Math.max(...lines);
  let rawMin = 0;
  for (let run = minRun; run <= maxRun; run++) {
    let pnl = 0;
    for (const bet of sessionBets) {
      pnl += fancyBetPnl(bet, run);
    }
    pnl = Math.round(pnl * 100) / 100;
    numberArray[run] = pnl;
    if (run === minRun || pnl < rawMin) rawMin = pnl;
  }
  return { numberArray, exposure: rawMin };
};

const bookExposer = (betList) => {
  const groups = {};
  for (const bet of betList || []) {
    if (bet.betType !== "session") continue;
    const selection = bet.selection;
    if (!groups[selection]) groups[selection] = [];
    groups[selection].push(bet);
  }
  return Object.keys(groups).map((selection) => {
    const stand = standForSessionBets(groups[selection]);
    return {
      selection,
      numberArray: stand.numberArray,
      exposure: stand.exposure,
    };
  });
};

export const bookExposerGetPopup = (betList) => {
  const sessionBets = (betList || []).filter((bet) => bet.betType === "session");
  return standForSessionBets(sessionBets).numberArray;
};
